'use strict';
import angular from 'angular';

angular.module('lineitems.constants', [])
    .constant('LineItemColumns', {
        ID: 'id'
    });